import { inject, Service } from '@angular/core';

import { FinancingService } from '../../projects/services/financing.service';
import { ProjectsService } from '../../projects/services/projects.service';

@Service()
export class LogoutImplicationsService {
    private readonly financingSvc = inject(FinancingService);
    private readonly projectsSvc = inject(ProjectsService);

    public clearCache(): void {
        this.projectsSvc.clearCache();
        this.financingSvc.removeClosestPayoutDateFromSessionStorage();
    }
}
